import handleResponse from './common';
import { requestReauth } from '../utils/reauth';

// Обёртка над fetch: при 401 запускает переаутентификацию через попап (модалка + Keycloak)
// и повторяет запрос один раз. Так истёкшая сессия обновляется без ухода со страницы.
const authFetch = async (url, options) => {
  let response = await fetch(url, options);
  if (response.status === 401) {
    await requestReauth();
    response = await fetch(url, options);
  }
  return handleResponse(response);
};

export default authFetch;
